export default "__VITE_ASSET__13479af8__"